import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const faqs = [
  {
    question: '¿Y si mi padre/madre no quiere hablar?',
    answer:
      'Es más común de lo que crees. Muchas veces no es que no quieran, es que nadie les ha pedido que cuenten su historia. Las preguntas de Ethernal están diseñadas para abrir conversaciones de manera natural. Empieza con un tema sencillo, sin presión.',
  },
  {
    question: '¿Necesito algún equipo especial?',
    answer:
      'No. Solo un teléfono móvil o un ordenador con micrófono. Ethernal funciona desde el navegador, sin instalar nada.',
  },
  {
    question: '¿Qué pasa si mi familiar no es bueno con la tecnología?',
    answer:
      'Ethernal está diseñado para personas de cualquier edad. Solo hay que pulsar un botón y hablar. También puedes sentarte con ellos y grabar juntos.',
  },
  {
    question: '¿Mis grabaciones son privadas?',
    answer:
      'Totalmente. Solo los miembros de tu familia que tú invites pueden acceder. Tus datos están cifrados y alojados en la UE.',
  },
  {
    question: '¿Cuánto tiempo lleva?',
    answer:
      'Cada tema toma entre 3 y 10 minutos. Puedes hacer uno por semana o varios en una tarde — lo importante es disfrutar la conversación. Muchas familias lo completan en 2-3 meses, pero no hay prisa.',
  },
  {
    question: '¿Puedo regalar Ethernal?',
    answer:
      'Sí. Puedes crear una cuenta y luego invitar a tu familiar para que empiece a grabar.',
  },
  {
    question: '¿Ethernal usa mi voz para entrenar inteligencia artificial?',
    answer:
      'No. Nunca. Lo que grabéis es vuestro. Solo se usa para transcribir las conversaciones y, si queréis, generar vuestro libro. Nadie más lo toca.',
  },
];

const FAQItem: React.FC<{
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}> = ({ question, answer, isOpen, onToggle }) => (
  <div className="border-b border-stone-200 last:border-b-0">
    <button
      onClick={onToggle}
      className="w-full flex items-center justify-between py-5 text-left gap-4 group"
    >
      <span className="text-base md:text-lg font-medium text-stone-900 group-hover:text-rose-600 transition-colors">
        {question}
      </span>
      <ChevronDown
        size={20}
        className={`text-stone-400 shrink-0 transition-transform duration-200 ${
          isOpen ? 'rotate-180' : ''
        }`}
      />
    </button>
    <div
      className={`overflow-hidden transition-all duration-200 ${
        isOpen ? 'max-h-40 pb-5' : 'max-h-0'
      }`}
    >
      <p className="text-stone-600 leading-relaxed text-sm md:text-base">
        {answer}
      </p>
    </div>
  </div>
);

const FAQSection: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-8 md:py-20 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-6 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-serif font-semibold text-stone-900">
            Preguntas frecuentes
          </h2>
        </div>

        <div className="max-w-3xl mx-auto bg-white rounded-2xl border border-stone-200 px-6 md:px-8">
          {faqs.map((faq, i) => (
            <FAQItem
              key={i}
              question={faq.question}
              answer={faq.answer}
              isOpen={openIndex === i}
              onToggle={() => setOpenIndex(openIndex === i ? null : i)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
